import Text from './Text';

export * from './Text';

export default Text;
